export default __webpack_public_path__ + "static/media/playerReport.e9fc45d2.svg";